const GOOGLE = {
  reCaptcha: '6LcU3swaAAAAAPfnU_5pKJZlJi2WFZTFwl8nX_Og'
}

export default GOOGLE